import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
const CONNECTED_BORDER_WIDTH_PX = 2;
export default function CodeInput({ ref, index, value, testId, onKeyDown, onFocus, onPaste, variant = 'separated', totalInputs = 6, disabled = false, autoFocus = false, compact = false, }) {
    const isFirst = index === 0;
    const isLast = index === totalInputs - 1;
    const isConnected = variant === 'connected';
    const isMiddleInput = variant === 'separated' && index === Math.ceil(totalInputs / 2) - 1;
    const connectedOverlapMarginLeft = isConnected && !isFirst && !compact ? -(index * CONNECTED_BORDER_WIDTH_PX) : undefined;
    return (_jsx("input", { ref: ref, style: connectedOverlapMarginLeft !== undefined ? { marginLeft: connectedOverlapMarginLeft } : undefined, type: "text", inputMode: "numeric", maxLength: 1, value: value === ' ' ? '' : value, onKeyDown: onKeyDown, onFocus: onFocus, onPaste: onPaste, disabled: disabled, autoFocus: autoFocus, onChange: () => { }, "data-testid": testId, className: classNames('text-heading bg-secondary-medium border-stroke-base-medium relative w-full min-w-0 text-center leading-6 font-semibold transition-colors outline-none', 'focus:border-brand focus:bg-brand-subtle focus:z-2', compact ? 'h-9 text-base' : 'h-14 text-2xl', {
            'border-2': !compact,
            border: compact && !isConnected,
            'border-l border-dashed': compact && isConnected && !isFirst,
            'rounded-xl': !isConnected && !compact,
            'rounded-lg': !isConnected && compact,
            'rounded-l-xl': isConnected && isFirst && !compact,
            'rounded-r-xl': isConnected && isLast && !compact,
            'rounded-l-lg': isConnected && isFirst && compact,
            'rounded-r-lg': isConnected && isLast && compact,
            'rounded-none': isConnected && !isFirst && !isLast,
            'mr-5': isMiddleInput,
            'cursor-not-allowed opacity-50': disabled,
        }) }));
}
